import React from 'react';
import columns from './columns';
import FiltersSection from './filters-section';
import messages from './messages';
import Breadcrumbs from 'components/Common/Breadcrumb';
import List from 'features/listing/list';
import Table from 'features/table';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';

const DirectoryCategoriesPage = () => {
  const {t} = useTranslation();

  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.title())}</title>
      </Helmet>
      <Container fluid>
        <Breadcrumbs
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {
              title: t(...messages.directories()),
              path: '/dashboard/directories',
            },
            {title: t(...messages.categories()), path: '#'},
          ]}
        />
        <Table
          columns={columns}
          url="directory-categories"
          name="directory-categories"
          filtersComponent={FiltersSection}
        />
      </Container>
    </div>
  );
};

export default DirectoryCategoriesPage;
